import SectionHeading from "@/pages/home/components/SectionHeading";
import { officialItems } from "@/mocks/digData";

const effectStyle: Record<string, string> = {
  降温: "bg-accent-100 text-accent-900 border-accent-200",
  发酵中: "bg-secondary-100 text-secondary-900 border-secondary-200",
  已澄清: "bg-background-200 text-foreground-800 border-background-300",
};

export default function OfficialSection() {
  return (
    <section id="official" className="scroll-mt-24 py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="OFFICIAL STATEMENT"
          title="官方回应专区 · 机构怎么说"
          desc="机构、节目组与品牌方的公开说明单独归档，并标注它对事件走向的影响：是被澄清、正在发酵，还是逐渐降温。"
        />

        <div className="mt-10 md:mt-14 flex flex-col gap-4 md:gap-5">
          {officialItems.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-100 overflow-hidden md:flex"
            >
              <div className="md:w-56 shrink-0 border-b md:border-b-0 md:border-r border-background-200 bg-background-200/50 p-4 md:p-5">
                <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/10">
                  <i className="ri-government-line text-primary-600" />
                </span>
                <p className="mt-3 font-heading text-base font-bold text-foreground-950">
                  {item.org}
                </p>
                <time className="mt-1 block text-xs text-foreground-500">{item.date}</time>
                <span
                  className={`mt-3 inline-block px-2.5 py-1 rounded-full text-xs border ${
                    effectStyle[item.effect]
                  }`}
                >
                  影响：{item.effect}
                </span>
              </div>
              <div className="flex-1 p-4 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.content}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}